<template>
	<div>

		<!-- do something if there's nod ata -->
		<div v-if="noData">
			<!-- make a gray rect -->
			<svg :width="width" height="200px">
				
				<!-- gray background -->
				<rect :width="width" height="200px" fill="gray" fill-opacity=".1"/>
				<g>
					<text
						class='chart-label-desc'
						:x="width / 2"
						y="100px"

						text-anchor="middle"
						dominant-baseline="middle"
					>
						No data available for this district
					</text>
				</g>
			</svg>
		</div>

		<!-- full chart -->
		<svg v-else :width="width" :height="height">
			
			<!-- gray background -->
			<rect :width="width" :height="height" fill="gray" fill-opacity=".1"/>

			<!-- legendLeft -->
			<g :transform="'translate(' + margins.svg[1] + ',' + (margins.svg[0] + legendTopHeight)  + ')'">
				
				<!-- category labels -->
				<text 
					v-for="(raceObj, r) in raceArr"
					:key="'categoryKey' + r"
					class='chart-label'
					:_class="{'is-missing': raceObj.missing}"

					x="0"
					:y="r * rowHeight + rowHeight/2"


					text-anchor="start"
					dominant-baseline="middle"
				>
					{{ raceObj.subgroup }}
				</text>
			</g>
			
			<!-- legendTop -->
			<g :transform="'translate(' + (margins.svg[1] + dims.legendLeft.width) + ',' + margins.svg[0] + ')'">

				<text 
					v-for="(num, n) in axisArr"
					:key="'legendTextKey' + n"
					
					class='axis-label'

					:x="scaleX(num/100)"
					:y="legendTopHeight - 10"

					text-anchor="middle"
					anchor-baseline="bottom"
				>
					{{ num }}
				</text>
			</g>

			<!-- chart window -->
			<g :transform="'translate(' + (margins.svg[1] + dims.legendLeft.width) + ',' + (margins.svg[0] + legendTopHeight) + ')'">
				

				<!-- y-axis -->
				<line 
					v-for="(num, n) in axisArr"
					:key="'yAxisTextKey' + n"
					
					class='axis'

					:x1="scaleX(num/100)"
					y1="0"

					:x2="scaleX(num/100)"
					:y2="dims.chart.height"
				/>

				<!-- bar -->
				<rect 
					:class="colorClass"

					v-for="(raceObj, r) in raceArr"
					:key="'barRectKey' + r"

					x="0"
					:y="r * rowHeight + rowHeight/2 - barHeight/2"

					:width="scaleX(raceObj.val)"
					:height="barHeight"

				/>

				<!-- missing-data message -->
				<text
					v-for="(raceObj, r) in raceArr"
					:key="'missingDataKey' + r"

					v-show="raceObj.missing"
					class='chart-label-desc'


					:x="10"
					:y="r * rowHeight + rowHeight/2 + 1"

					text-anchor="start"
					dominant-baseline="middle"
				>
					no data available
				</text>

				<!-- bar label -->
				<text
					class='chart-label-desc'

					v-for="(raceObj, r) in raceArr"
					:key="'barLabelKey' + r"

					:x="scaleX(raceObj.val) + 10"
					:y="r * rowHeight + rowHeight/2 + 1"

					text-anchor="start"
					dominant-baseline="middle"

				>
					{{ raceObj.displayVal }}
				</text>

			</g>
		</svg>
  </div>
</template>


<script>

import { mapGetters } from 'vuex';
import { scaleLinear } from 'd3-scale';

export default {
	props: {
		colorClass: String,
		width: Number,
		metric: String
	},
	data() {
		return {
			margins: {
				svg: [20, 20, 30, 10],
			},
			xRange: [0, 1]
		}
	},
	computed: {
		...mapGetters(['activeLeaRecords', 'isMobile']),
		labelBuffer() {
			return this.isMobile ? 40 : 65
		},
		legendLeftWidth() {
			return this.isMobile ? 100 : 150
		},
		legendTopHeight() {
			return this.isMobile ? 20 : 30
		},
		rowHeight() {
			return this.isMobile ? 35 : 40
		},
		barHeight() {
			return this.isMobile ? 16 : 20
		},
		raceArr() {
			let baseArr = [
				{'subgroup': 'Am. Indian'},
				{'subgroup': 'Asian'},
				{'subgroup': 'Black'},
				{'subgroup': 'Hispanic'},
				{'subgroup': 'Multi-racial'},
				{'subgroup': 'White'},
			]

			// filter to just this metric
			const data = this.activeLeaRecords.filter(x => x.metric === this.metric);

			// fill a new array
			let outArr = [];

			// for each race defined above
			// 	limit to that data
			//  	if data exists, add it
			// 		if data missing, add missing val
			baseArr.forEach(baseRecord => {
				let outRecord = baseRecord;

				const dataByRace = data.filter(x => x.subgroup === baseRecord.subgroup );

				if (dataByRace.length === 0) {
					outRecord['missing'] = true;
				} else {
					outRecord['missing'] = false;
					outRecord['val'] = dataByRace[0].val;
					outRecord['displayVal'] = dataByRace[0].display_val;
				}

				outArr.push(outRecord);
			});

			return outArr
		},
		noData() {
			const numRecords = this.raceArr.length;
			const missingRecs = this.raceArr.filter(x => x.missing);
			const numMissingRecs = missingRecs.length;
			return numMissingRecs >= numRecords
		},
		axisArr() {
			let out = []
			if (this.width < 769) {
				out = [0, 50, 100];
			} else {
				out = [0, 25, 50, 75, 100];
			}
			return out
		},
		height() {
			return this.margins.svg[0] + this.legendTopHeight + this.rowHeight * this.raceArr.length + this.margins.svg[2]
		},
		dims() {
			return {
				chart: {
					height: this.height - this.margins.svg[0] - this.margins.svg[2] - this.legendTopHeight,
					width: this.width - this.margins.svg[1] - this.margins.svg[3] - this.legendLeftWidth
				},
				legendTop: {
					height: this.legendTopHeight,
					width: this.width - this.margins.svg[1] - this.margins.svg[3] - this.legendLeftWidth
				},
				legendLeft: {
					height: this.height - this.margins.svg[0] - this.margins.svg[2] - this.legendTopHeight,
					width: this.legendLeftWidth
				}
			}
		}
	},
	methods: {
		scaleX(val) {
			var scale = scaleLinear()
				.domain(this.xRange)
				.range([0, this.dims.chart.width - this.labelBuffer]);
			return scale(val)
		}
	}
}
</script>